import React from 'react';
import ContactInfoWidget from '../Widget/ContactInfoWidget';
import MenuWidget from '../Widget/MenuWidget';
import SocialWidget from '../Widget/SocialWidget';
import TextWidget from '../Widget/TextWidget';
import navMenu from '../../data/navMenu';

export default function Footer() {
  return (
    <footer className="cs_footer cs_style_1 cs_heading_color">
      <div
        className="cs_footer_logo_wrap"
        style={{ backgroundImage: 'url(/images/footer_bg_1.svg)' }}
      >
        <div
          className="cs_footer_brand"
          style={{ backgroundImage: 'url(/images/footer_logo_bg.svg)' }}
        >
          <img
            src="/images/logo_icon.svg"
            alt="Logo Icon"
            className="cs_footer_brand_icon"
          />
          <h2 className="cs_footer_brand_text">Dr. L.D.<br></br>Ramiah</h2>
        </div>
      </div>
      <div className="cs_footer_main">
        <div className="container">
          <div className="row">
            <div className="col-lg-5">
              <div className="cs_footer_item">
                <TextWidget text="Dr. L.D. Ramiah <br />General Practitioner" />
                <ContactInfoWidget />
              </div>
            </div>
            <div className="col-lg-3">
              <div className="cs_footer_item">
                <h2 className="cs_widget_title">Quick Links</h2>
                <MenuWidget data={navMenu} />
              </div>
            </div>
            <div className="col-lg-4">
              <div className="cs_footer_item">
                <h2 className="cs_widget_title">Practice Hours</h2>
                <ul className="cs_menu_widget cs_mp0">
                  <li>Mon&ndash;Fri: 08:00 &ndash; 17:00</li>
                  <li>Sat: 08:00 &ndash; 12:00</li>
                  <li>Sun &amp; Public Holidays: Closed</li>
                  <li>
                    <em>Please call ahead to confirm availability.</em>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="cs_footer_bottom cs_accent_bg">
        <div className="container">
          <div className="cs_footer_bottom_in">
            <SocialWidget />
            <div className="cs_copyright">
              Copyright &copy; 2026 Dr. L.D. Ramiah. All rights reserved.
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
